import getIndexedDbStorageAsync, { IndexedDbStorage } from 'libs/rtzr-commons/IndexedDbStorage';

export type AppStorageKeys =
  | 'skip_onboarding'
  | 'expired_date_for_onboarding'
  | 'expired_date_for_new_feature'
  | 'new_popup_enable'
  | 'banner_closed_at'
  | 'tooltips'
  | 'skip_next_time'
  | 'recording_audio'
  | 'recorded_audios';

export type AppKeyValue = {
  key: AppStorageKeys;
  value: any;
};

export class AppStorage {
  /**
   *
   */
  constructor(private _storage: IndexedDbStorage) {}

  public set = async <T>(key: AppStorageKeys, data: T): Promise<void> => {
    await this._storage.setAsync<T>(key, data);
  };

  public get = async <T>(key: AppStorageKeys, force = false): Promise<T> => {
    return await this._storage.getAsync<T>(key, force);
  };

  public getMany = async <T>(keys: AppStorageKeys[], force = false): Promise<T[]> => {
    return await this._storage.getMany<T>(keys, force);
  };

  public remove = async (key: AppStorageKeys): Promise<void> => {
    await this._storage.removeAsync(key);
  };

  public removeMany = async (keys: AppStorageKeys[]): Promise<void> => {
    await this._storage.removeMany(keys);
  };

  public static create = async (): Promise<AppStorage> => {
    const storage = await getIndexedDbStorageAsync();
    return new AppStorage(storage);
  };
}
